import { Injectable, Inject } from '@angular/core';
import { Angulartics2 } from 'angulartics2';
import { Angulartics2GoogleAnalytics } from 'angulartics2/ga';
import { merge } from 'lodash';
import { environment } from '@env/environment';

declare const ga: any;

@Injectable()
export class AnalyticsService {

  private emailRegex: RegExp = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
  mixpanelEnabled: boolean = false;
  user: any = {};
  config = environment;

  constructor(
    private angulartics2: Angulartics2,
    private googleAnalytics: Angulartics2GoogleAnalytics,
  ) { }

  /**
   * Initialize mixpanel
   */
  init() {
    // default use GA
    if (this.config['ga'] && this.config['ga']['ua']) {
      ga('create', this.config.ga.ua, 'auto');
      this.googleAnalytics.startTracking();
    }
  }

  /**
   * Register user in mixpanel at signup
   * @param user user data
   */
  registerUser(user: any) {
    const _user = this.createUserData(user);
    this.user = _user;
    this.googleAnalytics.setUsername(_user.userId);
  }

  /**
   * Update mixpanel user data
   * @param user yser data
   */
  updateUser(user: any) {
    const _user = this.createUserData(user);
  }

  /**
   * Identify user in mixpanel
   */
  identify(user: any) {
    this.googleAnalytics.setUsername(user)
  }

  /**
   * Check if user it's idenfied by an email
   */
  identified() {
    return this.user.email ? true : false;
  }

  /**
   * reset mixpanel at logout
   */
  logout() {
    this.googleAnalytics.setUsername(null);
  }

  /**
   * Send event to analytics dashboards
   * @param action action name
   * @param properties  action payload
   * @param label action label for event
   */
  sendAnalyticsEvent(action: string, properties?: any, label?: string) {
    const payload: any = {
      action: action,
      properties: {
        category: label || 'Event',
        label: label || 'Event'
      }
    };

    if (properties)
      payload.properties = merge(payload.properties, properties);

    if (label)
      payload.label = label;

    // send event
    this.angulartics2.eventTrack.next(payload);
  }

  /**
   * Create user data to be stored on mixpanel
   * @param user user data
   */
  private createUserData(user: any) {
    user['$email'] = user.email;
    user['id'] = user.userId;

    if (user.firstName)
      user['$first_name'] = user.firstName;

    if (user.lastName)
      user['$last_name'] = user.lastName;

    if (user.createdAt)
      user['$created'] = user.createdAt;

    return user;
  }
}
